@if (categories$ | async; as categories) {
  <section class="subcategories" data-test="subcategories--container">
    <div class="subcategories--header" data-test="subcategories--header">
      <div class="subcategories--description-content">
        <div class="subcategories--title">
          <h1 class="head-underline__orange" data-test="subcategories--title">{{ categories?.name }}</h1>
          @if (categories.description) {
            <button
              data-test="subcategories--toggle-description-btn"
              class="btn subcategories--trigger-btn"
              (click)="onToggleDescriptionVisibility()"
            >
              @if (hasShowDescription()) {
                {{ 'subCategories.hideDescription' | cxTranslate }}
              } @else {
                {{ 'subCategories.showDescription' | cxTranslate }}
              }
              <mat-icon
                svgIcon="arrow-down" class="subcategories--icon"
                [ngClass]="{'subcategories--icon__expanded': hasShowDescription()}"
              ></mat-icon>
            </button>
          }
        </div>
        @if (hasShowDescription()) {
          <div
            data-test="subcategories--description"
            @fadeInContentByHeightOpacity class="subcategories--description"
            [innerHTML]="categories.description | trust: 'html'"
          ></div>
        }
      </div>

      @if (hasShowDescription()) {
        <cx-media
          @fadeInContentByOpacityOneWay class="subcategories--media"
          data-test="subcategories--media" [container]="categories.image"
        />
      }
    </div>
    @if (categories.subcategories.length) {
      <h2
        class="subcategories--subtitle h-500"
        data-test="subcategories--subtitle"
      >{{ 'subCategories.subtitle' | cxTranslate }}</h2>
    }
    @if (categories.subcategories.length) {
      @if (switcher$ | async; as switcher) {
        <div class="subcategories--list" data-test="subcategories--list">
          @for (category of categories?.subcategories | slice: switcher.shownFromIndex:switcher.shownToIndex;
            track category.id) {
            <dp-product-subcategory [category]="category" [attr.data-test]="'subcategories--' + category.id" />
          }
        </div>
        @if (switcher.totalLists > 1) {
          <dp-product-subcategory-switcher
            data-test="subcategories--switcher"
            [switcher]="switcher" (changeActive)="setActive($event)"
          ></dp-product-subcategory-switcher>
        }
      }
    }
  </section>
}
